module.exports = __webpack_public_path__ + "img/218.95fb0110.jpg";